import { render, staticRenderFns } from "./Form1_Persona2.vue?vue&type=template&id=7c609676"
import script from "./Form1_Persona2.vue?vue&type=script&lang=js"
export * from "./Form1_Persona2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c609676')) {
      api.createRecord('7c609676', component.options)
    } else {
      api.reload('7c609676', component.options)
    }
    module.hot.accept("./Form1_Persona2.vue?vue&type=template&id=7c609676", function () {
      api.rerender('7c609676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/ES/Persona/Form1_Persona2.vue"
export default component.exports